<template>
  <div class="edit-bill-box">
    <el-dialog
      title="商人追分"
      :visible.sync="dialogVisible"
      width="600px"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="params" label-width="200px" :rules="rules">
        <el-form-item label="用户ID:" prop="customerId">
          <el-input size="small" placeholder="请输入用户id" v-model="params.customerId"></el-input>
        </el-form-item>
        <el-form-item label="商人ID:" prop="traderId">
          <el-input size="small" placeholder="请输入商人ID" v-model="params.traderId" disabled></el-input>
        </el-form-item>
        <el-form-item label="用户金币:" prop="amount">
          <el-input size="small" placeholder="请输入用户金币" v-model="params.amount"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')" :loading="loading" size="small">确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import API from "@/api";
export default {
  data() {
    return {
      type: "", //弹出框类型
      dialogVisible: false,
      loading: false,
      // 状态列表
      params: {
        customerId: "",
        traderId: "",
        amount: "",
        confirm: false,
        delivery: false
      },
      rules: {
        customerId: [{ required: true, message: "必填", trigger: "change" }],
        traderId: [{ required: true, message: "必填", trigger: "change" }],
        amount: [{ required: true, message: "必填", trigger: "change" }]
      }
    };
  },
  methods: {
    // 关闭弹窗时
    handleClose() {
      this.dialogVisible = false;
      this.params = {
        traderId: ""
      };
      this.$refs["form"].resetFields();
    },
    // 表单验证提交
    submitForm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true;
          this.handleSeekScore();
        } else {
          return false;
        }
      });
    },

    handleSeekScore() {
      API.seekScore({
        traderId: this.params.traderId,
        customerId: parseInt(this.params.customerId),
        amount: this.params.amount,
        confirm: this.params.confirm
      })
        .then(res => {
          if (res.code === 200) {
            this.$message({
              message: "商人追分成功",
              type: "success"
            });
            this.$emit("handlerBillList");
            this.handleClose();
          }else {
            this.$message({
              message: "商人追分失败",
              type: "failed"
            });
          }
          this.handleClose();
          this.loading = false;
        })
        .catch(err => {
          this.loading = false;
          switch (err.response.data.code) {
            case 18007:
              (this.params.amount = err.response.data.msg
                .split(",")[0]
                .slice(9)),
                this.$confirm(err.response.data.msg + "?", "提示", {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning"
                }).then(() => {
                  this.params.confirm = true;
                });
              break;
            case 18006:
              this.$message({
                message: "追分失败,用户余额为零"
              });
              this.handleClose();
              break;
          }
        });
    },

    open(row) {
      this.dialogVisible = true;
      this.params = { ...row, ...{} };
      this.params.traderId = this.params.uid;
    }
  }
};
</script>
<style scoped>
.el-input {
  width: 220px;
}
</style>
